import { ref, computed } from 'vue'

import { defineStore, acceptHMRUpdate } from 'pinia'

import { useAuthStore } from '@/Stores'

import { deepCopy } from '@/Helpers';

export const SERVICE_VARIANT_OPTIONS = [
    {
        id: 'general',
        name: 'General',
    },
    {
        id: 'ct',
        name: 'CT',
    },
]

export const useConfigStore = defineStore('config', () => {

    const authStore = useAuthStore()

    const config = ref({
        contact: {
            types: [],
            professions: []
        },
        care_need: {
            expert_factors: [],
            health_conditions: []
        },
        matching_criteria_descriptor: {
            categories: [],
            criterias: []
        },
        states: [],
        prospect_rates: {
            daily: [],
            hourly: []
        },
        features: {}
    })

    async function retrieveConfig() {
        return await new Promise((resolve, reject) => {
            axios.get(
                `/api/v1/config`
            ).then(response => {
                config.value = { ...config.value, ...response.data }
            }).catch((err) => {
                authStore.handleError(err)
                reject({ "error": err })
            })
        });
    }

    const HealthConditionDict = computed(() => {
        const dict = {}
        config.value.care_need.health_conditions.forEach(item => {
            dict[item.id] = item
        })
        return dict
    })

    const ExpertFactorDict = computed(() => {
        const dict = {}
        config.value.care_need.expert_factors.forEach(item => {
            dict[item.id] = item
        })
        return dict
    })

    const criteriaNameDict = computed(() => {
        const dict = {}
        config.value.matching_criteria_descriptor.criterias.forEach(criteria => {
            dict[criteria.name_id] = deepCopy(criteria)
            dict[criteria.name_id]['attribute_dict'] = {}
            dict[criteria.name_id]['presentation'] = criteria.presentation
            criteria.attributes && criteria.attributes.forEach(attribute => {
                dict[criteria.name_id]['attribute_dict'][attribute.name_id] = attribute
            })
        })
        return dict
    })

    const clientCriterias = computed(() => {
        return config.value.matching_criteria_descriptor.criterias.filter(criteria => {
            if (criteria.applicable_type === 'client_only' || criteria.applicable_type === 'both') {
                return criteria.name_id.includes('caregiver_group') === false
            }
            return false
        })
    })

    const caregiverCriterias = computed(() => {
        const parentCriterias = config.value.matching_criteria_descriptor.criterias.filter(criteria => {
            return (criteria.applicable_type === 'caregiver_only' || criteria.applicable_type === 'both') && criteria.caregiver_parent_name_id === null
        })

        config.value.matching_criteria_descriptor.criterias.forEach(criteria => {
            if (criteria.applicable_type === 'caregiver_only' || criteria.applicable_type === 'both') {
                if (criteria.caregiver_parent_name_id !== null) {
                    const parentCriteria = parentCriterias.find(parent => parent.name_id === criteria.caregiver_parent_name_id)
                    if (parentCriteria) {
                        if (!parentCriteria.criterias) {
                            parentCriteria.criterias = []
                        }

                        if (!parentCriteria.criterias.some(c => c.name_id === criteria.name_id)) {
                            parentCriteria.criterias.push(criteria)
                        }
                    }
                }
            }
        })

        return parentCriterias
    })

    function featureEnabled(featureName) {
        return config.value.features[featureName] === true;
    }

    return {
        config, retrieveConfig, HealthConditionDict, ExpertFactorDict, criteriaNameDict,
        clientCriterias, caregiverCriterias, featureEnabled
    }
})

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useConfigStore, import.meta.hot))
}
